export type MfaData = {
  type: MfaOption
  code: string
}

export enum MfaOption {
  TOTP = 'totp',
  EMAIL = 'email',
  // legacy
  APP = 'app',
}
